// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"2307":"2da07c1086774951cfbe","2895":"f355930c907e33e3d97c","3976":"2da07c1086774951cfbe","4622":"d73b4beed5c813912e86"}[chunkId] + ".bundle.css";
};